import React from 'react';
import { ProductDetailsFragment } from '../../../../generated/types';
import { FavoriteButton } from '../../../Favorite';
import { LazyLoad } from '../../../LazyLoad';

import './ProductDetailsFavoriteSectionDesktop.scss';

interface Props {
  variant: ProductDetailsFragment;
}

export const ProductDetailsFavoriteSectionDesktop: React.FC<Props> = ({ variant }) => (
  <LazyLoad>
    <FavoriteButton className="ProductDetailsFavoriteSectionDesktop" variant={variant} />
  </LazyLoad>
);
